import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';
import './staff.css';

const staffTheme = createTheme({
    palette: { primary: { main: '#376b55' }, secondary: { main: '#a3453c' }, text: { primary: '#253c33', secondary: '#728078' }, divider: '#e3e9e1' },
    typography: { fontFamily: "'Segoe UI', Arial, sans-serif", button: { textTransform: 'none', fontWeight: 600 } },
    shape: { borderRadius: 10 },
    components: {
        MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 42, paddingInline: 18, borderRadius: 8 } } },
        MuiIconButton: { styleOverrides: { root: { minWidth: 40, minHeight: 40, fontSize: 17 } } },
        MuiOutlinedInput: { styleOverrides: { root: { background: '#fff', fontSize: 14 }, notchedOutline: { borderColor: '#dce4dd' } } },
        MuiTableCell: { styleOverrides: { root: { borderColor: '#edf0e9', padding: '18px 22px', fontSize: 13 }, head: { background: '#f5f7f1', color: '#728078', fontWeight: 600, fontSize: 11, letterSpacing: '.7px', textTransform: 'uppercase', whiteSpace: 'nowrap' } } },
        MuiTableRow: { styleOverrides: { root: { '&:hover td, &:hover th[scope="row"]': { background: '#fafbf7' } } } },
        MuiDialog: { defaultProps: { fullWidth: true, maxWidth: 'sm' }, styleOverrides: { paper: { borderRadius: 16, boxShadow: '0 24px 100px #253c3329', border: '1px solid #dce4dd' } } },
        MuiDialogTitle: { styleOverrides: { root: { fontWeight: 600, padding: '26px 28px 18px', borderBottom: '1px solid #e3e9e1' } } },
        MuiDialogContent: { styleOverrides: { root: { padding: '20px 28px' } } },
        MuiDialogActions: { styleOverrides: { root: { padding: '18px 28px', borderTop: '1px solid #e3e9e1', background: '#fafbf8' } } },
        MuiPaginationItem: { styleOverrides: { root: { borderRadius: 7 } } },
    },
});

export default function StaffLayout({ children }) {
    const [menuOpen, setMenuOpen] = useState(false);
    return <ThemeProvider theme={staffTheme}><div className="staff-app">
        <a className="staff-skip" href="#staff-content">Skip to content</a>
        {menuOpen && <button className="staff-menu-backdrop" aria-label="Close navigation" onClick={() => setMenuOpen(false)} />}
        <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
        <div className="staff-workspace"><TopNavbar onMenuToggle={() => setMenuOpen(!menuOpen)} menuOpen={menuOpen} /><main id="staff-content" className="staff-content" tabIndex={-1}>{children}</main><footer className="staff-footer"><span>Horizont Clinic</span><span>Care with a clear perspective.</span></footer></div>
    </div></ThemeProvider>;
}

export function PageHeading({ eyebrow = 'CLINIC WORKSPACE', title, description, action }) {
    return <div className="staff-page-heading"><div><p className="staff-eyebrow">{eyebrow}</p><h1>{title}</h1><p className="staff-description">{description}</p></div>{action && <div className="staff-heading-action">{action}</div>}</div>;
}

export function PersonName({ name, subtitle }) {
    const initials = (name || '?').trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('');
    return <div className="staff-person"><span className="staff-avatar" aria-hidden="true">{initials}</span><span><strong>{name}</strong>{subtitle && <small>{subtitle}</small>}</span></div>;
}

export function EmptyState({ title, description }) {
    return <div className="staff-empty"><span className="staff-empty-symbol" aria-hidden="true">＋</span><h3>{title}</h3><p>{description}</p></div>;
}
